<template>
  <div>
    <div class="page-content">
      <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
          <div class="card">
            <div class="card-header">
              <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
              &nbsp;&nbsp;&nbsp;
              <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Master Activity Create</h6>
              <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                <i class="link-icon" data-feather="repeat"></i>
                {{ $t('resetFormTxt') }}
              </button>
            </div>
            <div class="card-body">
              <div class="form-wrapper position-relative">
                <!-- Overlay loading -->
                <div v-if="isLoading" class="form-overlay d-flex justify-content-center align-items-center">
                  <div class="text-center">
                    <div class="spinner-border text-primary mb-2" role="status" aria-hidden="true"></div>
                    <div>
                      <strong>{{ $t('loadingTxt') }}...</strong>
                    </div>
                  </div>
                </div>

                <form class="forms-sample" @submit.prevent="submitData" method="POST">
                  <div class="d-flex justify-content-between align-items-baseline mb-2"></div>

                  <!-- category -->
                  <div class="row mb-3">
                    <label for="category" class="col-sm-2 col-form-label">Category</label>
                    <div class="col-sm-10">
                      <v-select
                        :options="fetchCategory"
                        v-model="forms.category"
                        label="label"
                        :reduce="(item) => item.value"
                        @search="asyncSearchCategory"
                        :loading="isSearchingCategory"
                        :class="{ 'is-invalid': errors.category }"></v-select>
                      <div v-if="errors.category">
                        <div v-for="error in errors.category" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                          <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                            {{ error }}
                            <i data-feather="alert-circle" class="me-1"></i>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <!-- job_no -->
                      <!-- <div class="row mb-3">
                        <label for="job_no" class="col-sm-4 col-form-label">Job No</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.job_no"
                            id="job_no"
                            placeholder="Job No"
                            :class="{ 'is-invalid': errors.job_no }" />
                          <div v-if="errors.job_no">
                            <div v-for="error in errors.job_no" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <!-- category_problem -->
                      <div class="row mb-3">
                        <label for="category_problem" class="col-sm-4 col-form-label">Category Problem</label>
                        <div class="col-sm-8">
                          <v-select
                            :options="fetchCategoryProblem"
                            v-model="forms.category_problem"
                            label="label"
                            :reduce="(item) => item.value"
                            @search="asyncSearchCategoryProblem"
                            :loading="isSearchingCategoryProblem"
                            :class="{ 'is-invalid': errors.category_problem }"></v-select>
                          <div v-if="errors.category_problem">
                            <div v-for="error in errors.category_problem" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- jenis_pekerjaan -->
                      <div class="row mb-3">
                        <label for="jenis_pekerjaan" class="col-sm-4 col-form-label">Jenis Pekerjaan</label>
                        <div class="col-sm-8">
                          <v-select
                            :options="fetchJenisPekerjaan"
                            v-model="forms.jenis_pekerjaan"
                            label="label"
                            :reduce="(item) => item.value"
                            @search="asyncSearchJenisPekerjaan"
                            :loading="isSearchingJenisPekerjaan"
                            :class="{ 'is-invalid': errors.jenis_pekerjaan }"></v-select>
                          <div v-if="errors.jenis_pekerjaan">
                            <div v-for="error in errors.jenis_pekerjaan" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- type_perbaikan -->
                      <div class="row mb-3">
                        <label for="type_perbaikan" class="col-sm-4 col-form-label">Type Perbaikan</label>
                        <div class="col-sm-8">
                          <v-select
                            :options="fetchTypePerbaikan"
                            v-model="forms.type_perbaikan"
                            label="label"
                            :reduce="(item) => item.value"
                            @search="asyncSearchTypePerbaikan"
                            :loading="isSearchingTypePerbaikan"
                            :class="{ 'is-invalid': errors.type_perbaikan }"></v-select>
                          <div v-if="errors.type_perbaikan">
                            <div v-for="error in errors.type_perbaikan" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <!-- description -->
                      <div class="row mb-3">
                        <label for="description" class="col-sm-4 col-form-label">Description</label>
                        <div class="col-sm-8">
                          <textarea
                            class="form-control"
                            id="description"
                            placeholder="Description"
                            v-model="forms.description"
                            rows="3"
                            :class="{ 'is-invalid': errors.description }"></textarea>
                          <div v-if="errors.description">
                            <div v-for="error in errors.description" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- fr -->
                      <div class="row mb-3">
                        <label for="fr" class="col-sm-4 col-form-label">
                          Flat Rate
                          <!-- <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.60rem;">
                          contoh format : 0.98
                        </small> -->
                        </label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.fr"
                            id="fr"
                            placeholder="format 0.000000"
                            @input="handleFlatRateInput"
                            :class="{ 'is-invalid': errors.fr }" />
                          <div v-if="errors.fr">
                            <div v-for="error in errors.fr" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- target_leadtime -->
                      <div class="row mb-3">
                        <label for="target_leadtime" class="col-sm-4 col-form-label">Target Leadtime</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.target_leadtime"
                            id="target_leadtime"
                            placeholder=""
                            @input="handleTimeInput"
                            :class="{ 'is-invalid': errors.target_leadtime }" />
                          <div v-if="errors.target_leadtime">
                            <div v-for="error in errors.target_leadtime" :key="error" class="alert alert-primary p-2 py-1" role="alert">
                              <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.7rem">
                                {{ error }}
                                <i data-feather="alert-circle" class="me-1"></i>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button class="btn btn-warning text-black fw-bolder btn-icon-text" @click="backForm" type="button">
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t('backMess') }}
                    </button>

                    &nbsp;&nbsp;&nbsp;
                    <button class="btn btn-primary float-end btn-sm" type="submit">
                      <i class="link-icon" data-feather="save"></i>
                      {{ $t('submitFormTxt') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!--end::card-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";
//import multiselect from "vue-multiselect";
//import DateRangePicker from "vue2-daterange-picker";
//import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: 'MasterActivityFppkAdd',
  props: {},
  components: {
    //multiselect: multiselect,
    //DateRangePicker,
  },
  data() {
    return {
      locale: {
        format: 'dd mmm yyyy H:MM:ss',
      },
      data: {},
      forms: {
        category: '',
        job_no: '',
        description: '',
        fr: '',
        target_leadtime: '',
        category_problem: '',
        jenis_pekerjaan: '',
        type_perbaikan: '',
      },
      fetchCategory: [],
      isSearchingCategory: false,
      fetchCategoryProblem: [],
      isSearchingCategoryProblem: false,
      fetchJenisPekerjaan: [],
      isSearchingJenisPekerjaan: false,
      fetchTypePerbaikan: [],
      isSearchingTypePerbaikan: false,

      opens: 'center',
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: 'up right',
      closeBtn: true,
      errors: [],
      userData: '',
      companyCode: '',
      company: [],
    };
  },
  watch: {
    'forms.fr'(val) {
      const regex = /^\d{1,20}(\.\d{0,6})?$/;

      if (!val) {
        this.errors.fr = null;
      } else if (!regex.test(val)) {
        this.errors.fr = ['contoh format : 0.98 ( maks 20 digit, decimal maks 6 digit)'];
      } else {
        this.errors.fr = null;
      }
    },
  },
  methods: {
    calculateLeadtime() {
      const fr = parseFloat(this.forms.fr);

      // fr bisa 0 atau lebih
      if (!isNaN(fr) && fr >= 0) {
        const totalSeconds = Math.round((fr / 24) * 86400);

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.forms.target_leadtime =
          `${hours.toString().padStart(2, '0')}:` + `${minutes.toString().padStart(2, '0')}:` + `${seconds.toString().padStart(2, '0')}`;
      } else {
        // kalau NaN, reset
        this.forms.target_leadtime = '';
      }
    },

    handleFlatRateInput(event) {
      let val = event.target.value;

      // Hapus semua kecuali angka dan titik
      val = val.replace(/[^0-9.]/g, '');

      // Izinkan satu titik saja
      const firstDotIndex = val.indexOf('.');
      if (firstDotIndex !== -1) {
        const beforeDot = val.slice(0, firstDotIndex);
        let afterDot = val.slice(firstDotIndex + 1).replace(/\./g, '');

        val = beforeDot.slice(0, 20) + '.' + afterDot.slice(0, 6);
      } else {
        val = val.slice(0, 20);
      }

      // Tetapkan ke v-model dan elemen input
      this.forms.fr = val;
      event.target.value = val;

      // Validasi longgar dulu, supaya 0. atau 1. bisa masuk
      const looseValid = /^\d{1,20}(\.)?(\d{0,6})?$/.test(val);

      // Validasi final untuk perhitungan leadtime
      const isFinalValid = /^\d{1,20}(\.\d{1,6})?$/.test(val) || val === '0';

      this.errors.fr = looseValid ? [] : ['contoh format : 0.98 ( maks 20 digit, decimal maks 6 digit )'];

      // Kalau valid final (bukan hanya nol titik), baru hitung
      if (isFinalValid) {
        //this.calculateLeadtime();
      } else {
        // Reset waktu kalau gak valid final
        //this.forms.target_leadtime = '';
      }
    },

   handleTimeInput(event) {
    let value = event.target.value.replace(/[^0-9]/g, '');

  // 🚫 Batasi maksimal 7 digit (3333333)
      if (value.length > 7) {
        value = value.slice(0, 7);
      }

      let formatted = '';

      if (value.length <= 3) {
        // jam (max 3 digit)
        formatted = value;
      } else if (value.length <= 5) {
        // jam + menit
        formatted = value.slice(0, value.length - 2) + ':' + value.slice(-2);
      } else {
        // jam + menit + detik
        formatted =
          value.slice(0, value.length - 4) +
          ':' +
          value.slice(-4, -2) +
          ':' +
          value.slice(-2);
      }

      this.forms.target_leadtime = formatted;
      this.errors.target_leadtime = [];
    },

    validateFlatRate() {
      const regex = /^\d{1,20}(\.\d{1,6})?$/;
      const value = this.forms.category;

      if (!value) {
        this.errors.fr = null;
      } else if (!regex.test(value)) {
        this.errors.fr = ['Format harus decimal dengan maksimal 20 digit sebelum koma dan 6 digit setelah koma.'];
      } else {
        this.errors.fr = null;
      }
    },

    asyncSearchTypePerbaikan(search) {
      this.isSearchingTypePerbaikan = true;
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawperb`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchTypePerbaikan = response.data.datas.data
            .map((item) => {
              const name = item.dependent_name;
              const label = name.includes('mawperb - ') ? name.split('mawperb - ')[1].trim() : name;
              return {
                label,
                value: label,
              };
            })
            .filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => a.label.localeCompare(b.label)); // <-- sort ascending
        })
        .finally(() => {
          this.isSearchingTypePerbaikan = false;
        });
    },

    loadTypePerbaikan() {
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawperb`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTypePerbaikan = response.data.datas.data
          .map((item) => {
            const name = item.dependent_name;
            const label = name.includes('mawperb - ') ? name.split('mawperb - ')[1].trim() : name;
            return {
              label,
              value: label, // ini yang akan disimpan di v-model
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // urutkan A-Z
      });
    },

    asyncSearchJenisPekerjaan(search) {
      this.isSearchingJenisPekerjaan = true;
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawjen`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchJenisPekerjaan = response.data.datas.data
            .map((item) => {
              const name = item.dependent_name;
              const label = name.includes('mawjen - ') ? name.split('mawjen - ')[1].trim() : name;
              return {
                label,
                value: label,
              };
            })
            .filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => a.label.localeCompare(b.label)); // <-- sort ascending
        })
        .finally(() => {
          this.isSearchingJenisPekerjaan = false;
        });
    },

    loadJenisPekerjaan() {
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawjen`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchJenisPekerjaan = response.data.datas.data
          .map((item) => {
            const name = item.dependent_name;
            const label = name.includes('mawjen - ') ? name.split('mawjen - ')[1].trim() : name;
            return {
              label,
              value: label, // ini yang akan disimpan di v-model
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // urutkan A-Z
      });
    },

    asyncSearchCategoryProblem(search) {
      this.isSearchingCategoryProblem = true;
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawprob`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchCategoryProblem = response.data.datas.data
            .map((item) => {
              const name = item.dependent_name;
              const label = name.includes('mawprob - ') ? name.split('mawprob - ')[1].trim() : name;
              return {
                label,
                value: label,
              };
            })
            .filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => a.label.localeCompare(b.label)); // <-- sort ascending
        })
        .finally(() => {
          this.isSearchingCategoryProblem = false;
        });
    },

    loadCategoryProblem() {
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawprob`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCategoryProblem = response.data.datas.data
          .map((item) => {
            const name = item.dependent_name;
            const label = name.includes('mawprob - ') ? name.split('mawprob - ')[1].trim() : name;
            return {
              label,
              value: label, // ini yang akan disimpan di v-model
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // urutkan A-Z
      });
    },

    asyncSearchCategory(search) {
      this.isSearchingCategory = true;
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawcat`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchCategory = response.data.datas.data
            .map((item) => {
              const name = item.dependent_name;
              const label = name.includes('mawcat - ') ? name.split('mawcat - ')[1].trim() : name;
              return {
                label,
                value: label,
              };
            })
            .filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => a.label.localeCompare(b.label)); // <-- sort ascending
        })
        .finally(() => {
          this.isSearchingCategory = false;
        });
    },

    loadCategoryMasterActivity() {
      const baseURI = this.$settings.endPointCt + `master-lookup/select-lookup-detail?unique_id=mawcat`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCategory = response.data.datas.data
          .map((item) => {
            const name = item.dependent_name;
            const label = name.includes('mawcat - ') ? name.split('mawcat - ')[1].trim() : name;
            return {
              label,
              value: label, // ini yang akan disimpan di v-model
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // urutkan A-Z
      });
    },

    resetForm() {
      this.forms = {};
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'MasterActivityController') {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = '/fppk-master-activity';
    },

    validateRequiredField(fieldName, fieldValue, translatedFieldName) {
      if (!fieldValue || (typeof fieldValue === 'object' && !fieldValue.value)) {
        // Tambahkan pesan error dengan "is required"
        const errorMessage = `${translatedFieldName} is required`;
        this.$set(this.errors, fieldName, [errorMessage]);
      } else {
        this.$delete(this.errors, fieldName);
      }
    },

    submitData() {
      this.errors = {}; // Reset errors

      // Validasi field secara dinamis menggunakan fungsi validateRequiredField
      this.validateRequiredField('category', this.forms.category, 'category');
      //this.validateRequiredField('job_no', this.forms.job_no, 'job_no');
      this.validateRequiredField('description', this.forms.description, 'description');
      this.validateRequiredField('fr', this.forms.fr, 'fr');
      this.validateRequiredField('target_leadtime', this.forms.target_leadtime, 'target_leadtime');
      this.validateRequiredField('category_problem', this.forms.category_problem, 'category_problem');
      this.validateRequiredField('jenis_pekerjaan', this.forms.jenis_pekerjaan, 'jenis_pekerjaan');
      this.validateRequiredField('type_perbaikan', this.forms.type_perbaikan, 'type_perbaikan');

      // Jika ada error, hentikan submit
      if (Object.keys(this.errors).length > 0) {
        return;
      }

      // Siapkan data yang akan dikirim sesuai user_type
      let data = {
        category: this.forms.category,
        job_no: this.forms.job_no,
        description: this.forms.description,
        fr: this.forms.fr,
        target_leadtime: this.forms.target_leadtime,
        category_problem: this.forms.category_problem,
        jenis_pekerjaan: this.forms.jenis_pekerjaan,
        type_perbaikan: this.forms.type_perbaikan,
      };

      // Debug untuk melihat data yang akan dikirim
      //console.log("Data yang dikirim : ", data);
      //return;

      // Lanjutkan proses submit ke backend
      this.$http
        .post(this.$settings.endPointFppk + 'v1/master-activity-fppk/create', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            var params = this.$onRandom(response.data.datas.master_activity_id);
            window.location.href = '/fppk-master-activity/detail/' + params + '?status=200&msg=Successfully';
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'success',
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'error',
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.calculateLeadtime();
    this.loadCategoryMasterActivity();
    this.loadCategoryProblem();
    this.loadJenisPekerjaan();
    this.loadTypePerbaikan();
  },
};
</script>
<style scoped></style>
